(function () {
  'use strict';
  const templates = document.querySelector('[data-ho-border-cart-templates]');
  if (!templates) return;

  document.addEventListener('addToCartFlyout:complete', (event) => {
    if (!event.detail || !event.detail.success) return;
    const response = event.detail.responseData;
    const added = response && (response.items && response.items[0] || response);
    if (!added) return;
    const variantId = String(added.variant_id || added.id || '');
    const template = [...templates.querySelectorAll('[data-ho-border-cart-template]')]
      .find((candidate) => candidate.dataset.hoBorderCartTemplate === variantId);
    if (!template) return;

    // The native completion event precedes insertion of its populated flyout.
    requestAnimationFrame(() => {
      const flyouts = document.querySelectorAll('[data-site-header] [data-atc-banner]');
      const flyout = flyouts[flyouts.length - 1];
      if (!flyout) return;
      const details = flyout.querySelector('.atc--product-details');
      const quantityLabel = flyout.querySelector('[data-atc-banner-product-price-quantity]');
      const match = quantityLabel && quantityLabel.textContent.match(/^\s*(\d+)\s*×/);
      const quantity = match && Number(match[1]);
      if (!details || !Number.isSafeInteger(quantity) || quantity < 1) return;

      const fragment = template.content.cloneNode(true);
      const breakdown = fragment.querySelector('[data-ho-border-breakdown]');
      if (!breakdown) return;
      const counts = breakdown.querySelectorAll('[data-ho-border-plant-count]');
      counts.forEach((count) => { count.textContent = String(quantity); });
      breakdown.querySelector('[data-ho-border-summary]').textContent = templates.dataset.addedSummary
        .replace('__PLANTS__', String(counts.length * quantity))
        .replace('__AREA__', String(quantity));
      details.querySelector('[data-ho-border-breakdown]')?.remove();
      details.appendChild(fragment);
    });
  });
})();
